import { resolve } from '@/core/di';
import { RealTimeCommunicationEventBinder } from './api/RealTimeCommunicationEventBinder';
import { ConfigurationService } from '../domain/configuration/ConfigurationService';

export const realTimeCommunicationEventBinder = (): RealTimeCommunicationEventBinder =>
  resolve(RealTimeCommunicationEventBinder);
export const configurationService = (): ConfigurationService => resolve(ConfigurationService);
